module.exports = __webpack_public_path__ + "static/media/runingMusic.d8da279.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/runingMusic.mp3
// module id = 1Bj4
// module chunks = 1